<template>
  <div class="container potentialSupplierManageDetail">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('supplierManage.basicInfo')" name="1">
        <!-- 基础信息 -->
        <div class="searchBox_top">
          <el-button type="primary" @click="historyBack">{{ $t('common.close') }}</el-button>
        </div>
        <div class="scrollYBox">
          <el-card class="box-card" v-if="emplFlag != 'SUP' && groupType == 'SUPPLIER'">
            <!--供应商品类信息-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.supplierCategoryInfo') }}</span>
            </div>
            <el-form :model="CategoryInfoForm" ref="CategoryInfoForm" label-width="120px">
              <el-row>
                <el-form-item :label="$t('supplierManage.Category1')" prop="categoryLevel1Id">
                  <el-checkbox-group v-model="CategoryInfoForm.categoryLevel1Id">
                    <el-checkbox disabled v-for="(item, index) in categoryList1" :label="item.tmCategoryId" :key="index">{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item :label="$t('supplierManage.Category2')" prop="categoryLevel2Id">
                  <el-checkbox-group v-model="CategoryInfoForm.categoryLevel2Id">
                    <el-checkbox disabled v-for="(item, index) in categoryList2" :label="item.tmCategoryId" :key="index"><span class="Categorypname">{{ item.pname
                      }}：</span>{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-row>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <!--保密协议-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.confidentialityAgreement') }}</span>
              <el-tag style='margin-left:20px;font-size: 15px;' type="danger">新供应商注册需完成保密协议签署，才能再进行后续的注册信息填写与提交</el-tag>
            </div>

            <el-table :data="lawFileList" ref="lawFileList" border highlight-current-row max-height='420'>
              <el-table-column :label="$t('supplierManage.fileName')">{{ $t('supplierManage.confidentialityAgreement')}}</el-table-column>
              <!--文件名-->
              <el-table-column :label="$t('common.file')" prop='current'>
                <!--文件-->
                <template>
                  <!--保密协议下载-->
                  <el-link type="primary" @click.native="downloadTemplate('/templates/download/附件二 麦当劳保密协议_CN.PDF', '附件二 麦当劳保密协议_CN.PDF')">附件二 麦当劳保密协议_CN.PDF</el-link>
                  <el-link type="primary" @click.native="downloadTemplate('/templates/download/附件二 麦当劳保密协议_ENCN.PDF', '附件二 麦当劳保密协议_ENCN.PDF')">附件二 麦当劳保密协议_ENCN.PDF</el-link>
                </template>
              </el-table-column>
              <el-table-column :label="$t('common.status')" prop='statusI18n'></el-table-column>
              <el-table-column :label="$t('base.linePrice.operation')" v-if='canEdit'>
                <template slot-scope="scope">
                  <el-link type="primary" v-show="scope.row.tmLawFileId" @click.native="seeLegalFileDetail(scope.row)">{{$t('common.see') }}</el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
          <el-card class="box-card">
            <!--供应商基础信息-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.supplierBasicInfo') }}</span>
            </div>
            <el-form :model="basicInfoForm" ref="basicInfoForm" label-width="140px">
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierChinese')" prop="supplierName">
                    <!--供应商中文名称-->
                    <el-input v-model="basicInfoForm.supplierName" clearable disabled maxlength="60"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierNameShort">
                    <!--供应商简称-->
                    <el-input v-model="basicInfoForm.supplierNameShort" clearable disabled maxlength="60"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierInvitationCode')" prop="invitationCode">
                    <!--供应商邀请码-->
                    <el-input v-model.trim="basicInfoForm.invitationCode" clearable disabled></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierEnglish')" prop="supplierNameEn">
                    <!--供应商英文名称-->
                    <el-input v-model.trim="basicInfoForm.supplierNameEn" clearable disabled maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierType')" prop="groupType">
                    <!--供应商类型-->
                    <ic-select clearable table="TM_SUPPLIER" field="GROUP_TYPE" v-model="basicInfoForm.groupType" disabled></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierInviter')" prop="inviter">
                    <!--供应商邀请人-->
                    <el-input v-model.trim="basicInfoForm.inviter" clearable disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.auditStatus')" prop="auditStatus">
                    <!--审核状态-->
                    <ic-select clearable table="TM_SUPPLIER" field="AUDIT_STATUS" v-model="basicInfoForm.auditStatus" disabled></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.socialUniformCreditCode')" prop="socialUniformCreditCode">
                    <!--社会统一信用代码-->
                    <el-input v-model.trim="basicInfoForm.socialUniformCreditCode" clearable disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-form :model="formlinkUsers" ref="formlinkUsers">
              <el-table :data="formlinkUsers.linkUsersList" ref="linkUsersList" border highlight-current-row max-height='420'>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('supplierManage.supplierContacts')" min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.supplierTel')" min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="email" label="邮箱" min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="title" :label="$t('supplierManage.position')" min-width="120">
                  <template slot-scope="scope">
                    {{scope.row.title | ic('TM_SUPPLIER','CONTACT_POSITION')}}
                    <!-- <ic-select table="TM_SUPPLIER" field="CONTACT_POSITION" disabled v-model="scope.row.title" style="width:100%"></ic-select> -->
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <!--供应商地址信息-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.supplierAddressInfo') }}</span>
            </div>
            <el-form :model="formAddress" ref="formAddress">
              <el-table :data="formAddress.plantList" ref="plantList" border highlight-current-row max-height='420' class="addressBox">
                <!-- 中文名称 -->
                <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('sys.roleList.roleCN')" min-width="120"></el-table-column>
                <!-- 英文名称 -->
                <el-table-column show-overflow-tooltip prop="supplierNameEn" :label="$t('sys.roleList.roleEN')" min-width="120"></el-table-column>
                <!-- 地址类型 -->
                <el-table-column show-overflow-tooltip prop='plantType' :label="$t('settlementUnit.addressType')" min-width="120">
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.plantType'">
                      <el-select v-model="scope.row.plantType" disabled>
                        <el-option key="REG" label="注册地址" value="REG"></el-option>
                        <el-option key="PLANT" label="工厂地址" v-if="groupType == 'SUPPLIER'" value="PLANT"></el-option>
                        <el-option key="WAREHOUSE" label="仓库" v-else value="WAREHOUSE"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--区域-->
                <el-table-column show-overflow-tooltip prop="tmAreaId" :label="$t('supplierManage.area')" min-width="180">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-if="scope.row.tmAreaId">{{scope.row.areaName }}</el-link>
                    <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-else>{{scope.row.countryTxt }}{{ scope.row.provinceTxt }}{{ scope.row.cityTxt }}{{ scope.row.districtTxt}}</el-link>
                  </template>
                </el-table-column>
                <!-- 详细地址 -->
                <el-table-column show-overflow-tooltip prop="address" :label="$t('settlementUnit.detailAddress')" min-width="120"></el-table-column>
                <!-- 联系人 -->
                <el-table-column show-overflow-tooltip prop="linkman" :label="$t('settlementUnit.contacts')" min-width="120">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.linkman">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name}}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <span>{{ scope.row.linkman}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 联系电话 -->
                <el-table-column show-overflow-tooltip prop="telephoneNo" :label="$t('settlementUnit.supplierTel')" min-width="120">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.telephoneNo">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name}}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <span>{{ scope.row.telephoneNo}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="contactOfficeTel" label="办公室电话" min-width="120">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.contactOfficeTel">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name}}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <span>{{ scope.row.contactOfficeTel}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 邮箱 -->
                <el-table-column show-overflow-tooltip prop="emailAddress" :label="$t('sys.userList.email')" min-width="120">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.emailAddress">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name}}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <span>{{ scope.row.emailAddress}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 邮编 -->
                <el-table-column show-overflow-tooltip prop="postCode" :label="$t('settlementUnit.Postcode')" min-width="120"></el-table-column>
                <!-- 资质文件 -->
                <el-table-column show-overflow-tooltip :label=" $t('settlementUnit.qualificationFile')" min-width="80" v-if="isGroup">
                  <template slot-scope="scope">
                    <i class="el-icon-folder-checked iconUploadSuccess" v-if="scope.row.existsFile == 'Y'"></i>
                    <el-link type="primary" @click="seeQualificationFile(scope.row, scope.$index)">{{ $t('common.upload')}}</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <!--其他附件-->
            <div slot="header" class="clearfix" style="display: flex;align-items: center;">
              <span>{{ $t('common.otherAttachments') }}</span>
            </div>
            <el-table :data="fileList" border highlight-current-row class="table">
              <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                <!--文件-->
                <template slot-scope="scope">
                  <el-link type="primary" @click.native="downloadFile(scope.row)">{{ scope.row.documentName }} </el-link>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
              <!--创建人-->
              <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
                <!--创建时间-->
                <template slot-scope="scope">
                  {{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm") }}
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="2">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime')">
            <template slot-scope="scope">{{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss") }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion')">
            <template slot-scope="scope">
              <div v-html="scope.row.comments"></div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :visible.sync="AreaDialog" width="400px">
      <!--区域弹框-->
      <el-form :model="AreaForm" ref="AreaForm" label-width="60px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.country')" prop="country">
              <!--国家-->
              <el-select v-model="AreaForm.country" :placeholder="$t('common.sel')" @change="countryChange" disabled>
                <el-option clearable v-for="item in countryList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.province')" prop="province">
              <!--省份-->
              <el-select v-model="AreaForm.province" :placeholder="$t('common.sel')" @change="provinceChange" disabled>
                <el-option clearable v-for="item in provinceList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.city')" prop="city">
              <el-select v-model="AreaForm.city" :placeholder="$t('common.sel')" @change="cityChange" disabled>
                <el-option clearable v-for="item in cityList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('DC.tmAreaId')" prop="tmAreaId">
              <el-select v-model="AreaForm.tmAreaId" :placeholder="$t('common.sel')" @change="AreaChange" disabled>
                <el-option clearable v-for="item in AreaList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="AreaDialog = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="qualificationsDialog" width="50%" :before-close='closeQualificationsDialog'>
      <!--资质文件弹框-->
      <el-table :data="qualificationsList" border highlight-current-row class="table">
        <el-table-column show-overflow-tooltip prop="HeaderName" :label="$t('common.file')" max-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="documentName" :label="$t('supplierManage.fileName')">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.tmDocumentId" @click.native="downloadQualifications(scope.row)">{{
              scope.row.documentName }} </el-link>
            <span v-else>{{ scope.row.documentName }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="closeQualificationsDialog">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import supplierApi from "@/api/supplier/supplier";
import commonFun from "@/utils/commonFun";
import commonConstatns from "@/constants/commonConstants";
import { apiService } from "@/api/material/material-master-data";
export default {
  components: { IcSelect },

  data() {
    return {
      canEdit: '',
      canAudit: '',
      canUpdate: '',
      auditStatus: '',
      addressAddSupplierContactListDialog: false,
      currentTab: '1',
      auditLog: [],//审批日志
      categoryList1: [],
      categoryList2: [],
      contactsList: [1],
      basicInfoForm: {},
      fileList: [],
      supplierCode: false,
      CategoryInfoForm: {
        categoryLevel1Id: [],
        categoryLevel2Id: [],
      },
      countryName: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      supplierCategoryList: [],
      lawFileList: [],
      rowIndex: '',
      countryList: [],
      provinceList: [],
      cityList: [],
      AreaList: [],
      AreaDialog: false,
      AreaForm: {
        country: '',
        province: '',
        city: '',
        tmAreaId: '',
      },
      qualificationsDialog: false,
      tmSupplierId: '',
      groupType: '',
      detailData: {},
      formlinkUsers: {
        linkUsersList: [],
      },
      formAddress: {
        plantList: [{ plantType: 'REG', status: '1', existsFile: 'N' }, { plantType: 'PLANT', status: '1', existsFile: 'N' }],
      },
      qualificationsList: [],
      QualificationFileId: '',//上传资质文件用到的id
      seq: '',
      haveQualifications: false,
      lawFile: [],//保密协议
      DestroyIncomeStatistics: "",
      emplFlag: "",
      isGroup: true
    }
  },
  computed: {
    fileUploadUrl() {
      if (commonFun.isNotEmpty(this.bizId) && this.bizId > 0) {
        return commonConstatns.fileUploadUrl + `/${this.recType}${this.seq == null ? '' : '/' + this.seq}/${this.bizId}`;
      } else {
        return commonConstatns.fileUploadUrl;
      }
    },
  },
  created() {
    if (this.$route.query.tmSupplierId) {
      this.tmSupplierId = this.$route.query.tmSupplierId;
    } else {
      this.tmSupplierId = this.$route.query.id;
    }
    this.groupType = this.$route.query.groupType;
    if (this.$route.query.groupType == 'CARRIER') {//如果是承运商,DC 地址只有一行
      this.formAddress.plantList.pop()
    }
    if (this.$route.query.groupType == 'DC') {
      this.formAddress.plantList[1].plantType = 'WAREHOUSE'
    }
    this.getDetail(this.tmSupplierId)
    this.getFiles();
    this.getArea()
    this.getCategoryList()
    let emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      this.getCategoryList()
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
      }
    }
  },
  mounted() {
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    let groupableSupplier = localStorage.getItem("groupableSupplier")//true是HGS供应商
    if (((!dataScope || (dataScope && dataScope == "GROUP_ADMIN")) && groupableSupplier == 'true') || groupableSupplier == 'false' || ms_roles.indexOf('MDM_TEAM') !== -1) {
      this.isGroup = true
    } else {
      this.isGroup = false
    }
  },
  methods: {
    getDetail(tmSupplierId) {
      let that = this
      supplierApi.potentialSupplierDetail(tmSupplierId).then(res => {
        this.detailData = res.data
        this.groupType = res.data.groupType
        this.auditStatus = res.data.auditStatus
        this.basicInfoForm = {
          supplierName: res.data.supplierName,
          supplierNameShort: res.data.supplierNameShort,
          invitationCode: res.data.invitationCode,
          auditStatus: res.data.auditStatus,
          supplierNameEn: res.data.supplierNameEn,
          groupType: res.data.groupType,
          inviter: res.data.inviter,
          socialUniformCreditCode: res.data.socialUniformCreditCode,
        }
        let linkUsersList = res.data.supplierContactList
        if (linkUsersList.length > 0) {
          for (let i = 0, len = linkUsersList.length; i < len; i++) {
            linkUsersList[i].delIds = i;
          }
          this.formlinkUsers.linkUsersList = linkUsersList
        }
        if (that.groupType == 'SUPPLIER' || that.groupType == 'DC') {
          let plantList = res.data.plantList
          if (plantList.length > 0) {
            for (let i = 0, len = plantList.length; i < len; i++) {
              plantList[i].delIds = i;
            }
            that.formAddress.plantList = plantList
          }
        } else {
          if (res.data.plantList.length != 0) {
            that.formAddress.plantList = res.data.plantList
          }

        }
        if (that.groupType == 'DC') {
          that.formAddress.plantList[1].plantType = 'WAREHOUSE'
        }
        that.lawFileList = [res.data.lawFile]
        that.auditLog = res.data.workFlowLogList
        that.canEdit = res.data.canEdit
        that.canAudit = res.data.canAudit
        that.canUpdate = res.data.canUpdate

        this.supplierCategoryList = res.data.supplierCategoryList
        let supplierCategoryList = res.data.supplierCategoryList

        let categoryLevel1IdTemp = []
        supplierCategoryList.forEach((item) => {
          categoryLevel1IdTemp.push(item.categoryLevel1Id);
          that.CategoryInfoForm.categoryLevel2Id.push(item.categoryLevel2Id);
        });

        that.CategoryInfoForm.categoryLevel1Id = Array.from(new Set(categoryLevel1IdTemp))
        if (supplierCategoryList.length > 0) {
          apiService.findCategory({ categoryLevel: 2, pidList: that.CategoryInfoForm.categoryLevel1Id }).then((resCategory) => {
            console.log(resCategory)
            that.categoryList2 = resCategory.data
          });
        }
        if (res.data.groupType == 'CARRIER' && that.formAddress.plantList.length == 2) {
          that.formAddress.plantList.pop()
        }
      });
    },
    selectArea(row, index) {
      let that = this
      //取出省市区 带到弹框中
      this.rowIndex = index
      if (commonFun.isNotEmpty(row.country)) {
        that.countryChange(row.country)
        that.provinceChange(row.province)
        that.cityChange(row.city)
      }
      Promise.all([that.countryChange(), that.provinceChange(), that.cityChange()]).then(() => {
        if (commonFun.isNotEmpty(row.country)) {
          that.AreaForm.country = parseInt(row.country)
          that.AreaForm.province = parseInt(row.province)
          that.AreaForm.city = parseInt(row.city)
          that.AreaForm.tmAreaId = row.tmAreaId
        }
      })
      this.AreaDialog = true
    },
    //获取国家
    getArea() {
      let that = this
      let data = {
        areaLevel: '0',
      }
      supplierApi.getArea(data).then(res => {
        this.countryList = res.data
      });
    },
    //国家选择之后 获取省份
    countryChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.countryList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.countryName = selectedWorkName.name
        }
        that.AreaForm.province = ''
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '1',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.provinceList = res.data
          resolve()
        });
      })
    },
    //省份选择之后 获取市
    provinceChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.provinceList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.provinceName = selectedWorkName.name
        }
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '2',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.cityList = res.data
          resolve()
        });
      })

    },
    //城市选择之后 获取区域
    cityChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.cityList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.cityName = selectedWorkName.name
        }
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '3',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.AreaList = res.data
          resolve()
        });
      })

    },
    //国家省市区全部选完
    AreaChange(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.AreaList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      if (selectedWorkName) {
        that.areaName = selectedWorkName.name
      }
    },
    //查看资质文件
    seeQualificationFile(row, index) {
      let that = this
      this.rowIndex = index
      this.QualificationFileId = row.tmSupplierId
      this.qualificationsDialog = true
      let groupType = this.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
      if (row.tmSupplierId) {//如果有id，获取一下 三种资质文件
        this.getBusinessLicense()
        this.getProductionLicense()
        this.getManagementLicense()
      } else {//还没有id 没保存
        if (row.businessCertificateDocument) {
          let obj = Object.assign({}, that.qualificationsList[0], row.businessCertificateDocument)
          that.qualificationsList.splice(0, 1, obj);
        }
        if (row.productionLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[1], row.productionLicenseDocument)
          that.qualificationsList.splice(1, 1, obj);
        }
        if (row.businessLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[2], row.businessLicenseDocument)
          that.qualificationsList.splice(2, 1, obj);
        }
      }
    },
    //获取资质文件 营业执照
    getBusinessLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_CERTIFICA';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {

        if (fileRes.length > 0) {
          // 通过splice()方法，删除某个元素后，再添加一个元素，达到“赋值”的效果 否则页面不会从新渲染
          let obj = Object.assign({}, that.qualificationsList[0], fileRes[0])
          that.qualificationsList.splice(0, 1, obj);
          // that.qualificationsList[0] = Object.assign({}, that.qualificationsList[0], fileRes[0])
          // that.qualificationsList[0] = Object.assign(that.qualificationsList[0],fileRes[0])
          // console.log(fileRes)
        }
      })
    },
    //获取资质文件 生产许可证
    getProductionLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'PRODUCTION_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[1], fileRes[0])
          that.qualificationsList.splice(1, 1, obj);
        }

      })
      console.log("2222")
    },
    //获取资质文件 经营许可证
    getManagementLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[2], fileRes[0])
          that.qualificationsList.splice(2, 1, obj);
        }

      })
      console.log("33333")
    },
    getFileIndex(index) {
      let that = this
      switch (index) {
        case 0:
          that.seq = 'BUSINESS_CERTIFICA'
          break;
        case 1:
          that.seq = 'PRODUCTION_LICENSE'
          break;
        case 2:
          that.seq = 'BUSINESS_LICENSE'
          break;
      }
    },
    //下载资质文件
    downloadQualifications(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //关闭地址中的上传资质文件
    closeQualificationsDialog() {
      let that = this
      this.qualificationsDialog = false
      let groupType = this.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //跳到法务文件详情
    seeLegalFileDetail(row) {
      this.$router.push({
        path: `/LegalFileDetail`,
        query: { id: row.tmLawFileId }
      });
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.tmSupplierId;
      attachment.tsReckindId = 'GROUP_OTHER';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    historyBack: function () {
      this.$router.go(-1);
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}

.scrollYBox {
  overflow-y: scroll;
  max-height: 800px;
}
</style>
<style lang="scss">
.addressBox .el-input__suffix {
  display: none;
}

.potentialSupplierManageDetail {
  .Categorypname {
    color: #409eff;
  }

  .iconUploadSuccess {
    font-size: 24px;
    color: #f8ab01;
    position: absolute;
    top: 20px;
    right: 6px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
}
</style>

